<template>
  <BaseAlertMessage
    class="tw:mb-2"
    type="info"
  >
    <span>{{ getLocaleText("broadcast_mention_card.expired_content") }}</span>
  </BaseAlertMessage>
</template>

<script setup lang="ts">
import { getLocaleText } from "shared/boot/i18n";
import { BaseAlertMessage } from "shared/components/base";
</script>
